var TorsoFormModel = require('backbone-torso/modules/FormModel');

/**
 * Form Model for Patient Portal Settings Security Questions Form
 * @class PatientSettingsSecurityQuestionsFormModel
 * @extends TorsoFormModel
 */

var PatientSettingsSecurityQuestionsFormModel = TorsoFormModel.extend({
  mapping: {
    portalUserModel: 'securityQuestion1 securityAnswer1 securityQuestion2 securityAnswer2'
  },

  /**
   * The validation rules for this form model
   * @property validation
   */
  validation: {
    securityQuestion1: {
      requiredField: 'true'
    },
    securityAnswer1: {
      requiredField: 'true'
    },
    securityQuestion2: {
      requiredField: 'true',
      fn: function(securityQuestion2) {
        var securityQuestion1 = this.get('securityQuestion1');
        if (securityQuestion1 && securityQuestion1 === securityQuestion2) {
          return {
            key: 'error.unique'
          };
        }
      }
    },
    securityAnswer2: {
      requiredField: 'true'
    },
  }
});

module.exports = PatientSettingsSecurityQuestionsFormModel;
